<div class="modal-header">
    <h5 class="modal-title">{{title}}</h5>
    <button type="button" class="btn-close" (click)="dismissModal()" aria-label="Close"></button>
</div>
<div class="modal-body">
    <div>{{prompt}}</div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-round btn-lg" [ngClass]="cancelBtnClass" (click)="dismissModal()"><i class="far " *ngIf="cancelBtnIcon" [ngClass]="cancelBtnIcon"></i> {{cancelBtnText}}</button>
    <button type="submit" class="btn btn-round btn-lg" [ngClass]="okBtnClass" (click)="confirmModal()"><i class="far " *ngIf="okBtnIcon" [ngClass]="okBtnIcon"></i> {{okBtnText}}</button>
</div>